import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { ButtonGroupDisplay, ButtonGroupSize } from './types'
import { buttonGroupSizeMap } from './types'

@safeCustomElement('mdc-button-group')
export class MdcButtonGroup extends LitElement {
  @property({ type: String }) size: ButtonGroupSize = 'md'
  @property({ type: String }) display: ButtonGroupDisplay = 'inline'

  static styles = css`
		:host {
			display: block;
			/* CSS Custom Properties for customization */
			--mdc-button-group-gap: var(--spacing-075, 0.75rem);
			font-family: var(--typography-font-family-sans);
		}

		.mdc-button-group {
			display: inline-flex;
			gap: var(--mdc-button-group-gap);
		}

		.mdc-button-group--display-stacked {
			flex-direction: column;
		}

		.mdc-button-group--display-inline {
			flex-direction: row;
		}

		::slotted(mdc-button) {
			/* Ensure buttons inside the group use the correct size */
		}
	`

  connectedCallback() {
    super.connectedCallback()
    this.updateButtonSizes()
  }

  updated(changedProperties: Map<PropertyKey, unknown>) {
    super.updated(changedProperties)
    if (changedProperties.has('size')) {
      this.updateButtonSizes()
    }
  }

  private updateButtonSizes() {
    const buttonSize = buttonGroupSizeMap[this.size]
    const buttons = this.querySelectorAll('mdc-button')
    buttons.forEach((button) => {
      button.setAttribute('size', buttonSize)
    })
  }

  render() {
    const className = `mdc-button-group mdc-button-group--size-${this.size} mdc-button-group--display-${this.display}`

    return html`
			<div class=${className}>
				<slot></slot>
			</div>
		`
  }
}
